import { useAppDispatch } from "@/config/configureAppStore";
import { setNotificationPermissionDialog } from "@/reducers/slices/dialogSlice/dialogSlice";
import { getIllustrationUrl } from "@/utils/links";
import { CloseRounded } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import useDesktopNotifications from "../hooks/useDesktopNotifications";
import { trackMixpanelEvent } from "@/utils/mixpanel";
import { MIXPANEL_EVENTS } from "@/constants/mixpanel";

const NotificationPermissionDialog = () => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setNotificationPermissionDialog(false));
  };
  const { askPermission } = useDesktopNotifications();

  return (
    <Dialog
      onClose={handleClose}
      open={true}
      PaperProps={{
        elevation: 0
      }}
    >
      <DialogTitle sx={{ textAlign: "end" }}>
        <IconButton onClick={handleClose}>
          <CloseRounded sx={{ height: 24, width: 24 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Stack gap={2} px={3} py={1}>
          <img
            src={getIllustrationUrl({
              illustrationNameWithExtension: "notification-alert.svg"
            })}
            alt="Notification Alert"
          />
          <Stack
            gap={1}
            sx={{
              justifyContent: "center",
              alignContent: "center",
              textAlign: "center"
            }}
          >
            <Typography variant="h6" color={"text.primary"}>
              We are processing your dubs and it’ll take some time
            </Typography>
            <Typography variant="body2" color={"text.secondary"}>
              We will notify you once your files are dubbed
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          padding: 3,
          pb: 4,
          justifyContent: "center"
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            askPermission();
            trackMixpanelEvent(MIXPANEL_EVENTS.NOTIFY_ME_SUCCESS);
            handleClose();
          }}
        >
          Notify Me
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationPermissionDialog;
